// src/routes/AppRoutes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts and Auth
import RoleRoute from "./RoleRoute";

import SuperAdminDashboard from "../pages/superadmin/Dashboard";
import SuperAdminUserManagement from "../pages/superadmin/UserManagement";
import SuperAdminSegmentation from "../pages/superadmin/Segmentation";
import SuperAdminPricingRules from "../pages/superadmin/PricingRules";

import ManagerDashboard from "../pages/admin/Dashboard";
import TitApplicationManagement from "../pages/admin/TokenApplicationManagement"
import ManagerContractManagement from "../pages/admin/ContractManagement"
import TitTats from "../pages/admin/TitTats"
import AdminLiveBidSessions from "../pages/admin/AdminLiveBidSessions";
import AdminAuctionRoom from "../pages/admin/AdminAuctionRoom";
import ManagerAccords from "../pages/admin/ManagerAccords";

import ArtistDashboard from "../pages/artist/artistDashboard";
import ArtWorks from "../pages/artist/ArtWorks";
import TokenApplicationManagement from "../pages/artist/titApplicationManage"
import TitTatsArtist from "../pages/artist/TitTats"
import ArtistContractManagement from "../pages/artist/ContractManagement"
import MyShop from "../pages/artist/MyShop";
import ShopOrders from "../pages/artist/ShopOrders";

import InvestorDashboard from "../pages/investor/InvestorDashboard";
import LiveBidSessions from "../pages/investor/LiveBidSessions";
import AuctionRoom from "../pages/investor/AuctionRoom";
import InvestorHoldings from "../pages/investor/InvestorHoldings";
import InvestorAccords from "../pages/investor/InvestorAccords";
import TradingFloor from "../pages/investor/TradingFloor";

import WalletPage from "../pages/wallet/WalletPage";

import AuthPage from "../pages/public/AuthPage";
import Home from "../pages/public/home";
import About from "../pages/public/aboutPage"
import ArtworksPage from "../pages/public/ArtworksPage";
import MarketplacePage from "../pages/marketplace/MarketplacePage";
import ArtistShop from "../pages/marketplace/ArtistShop";
import ArtworkDetail from "../pages/marketplace/ArtworkDetail";
import CheckoutPage from "../pages/marketplace/CheckoutPage";
import OrderTrack from "../pages/marketplace/OrderTrack";
import OrderSuccess from "../pages/marketplace/OrderSuccess";
import OrderCancel from "../pages/marketplace/OrderCancel";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/signup" element={<AuthPage />} />
      <Route path="/artworks" element={<ArtworksPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/marketplace/shop/:artistId" element={<ArtistShop />} />
      <Route path="/marketplace/art/:artId" element={<ArtworkDetail />} />
      <Route path="/marketplace/checkout/:artId" element={<CheckoutPage />} />
      <Route path="/marketplace/track" element={<OrderTrack />} />
      <Route path="/marketplace/order/success" element={<OrderSuccess />} />
      <Route path="/marketplace/order/cancel" element={<OrderCancel />} />
      <Route path="/about" element={<About />} />
      <Route
        path="/superadmin/dashboard"
        element={
          <RoleRoute role="superadmin">
            <SuperAdminDashboard />
          </RoleRoute>
        }
      />
      <Route
        path="/superadmin/dashboard/users"
        element={
          <RoleRoute role="superadmin">
            <SuperAdminUserManagement />
          </RoleRoute>
        }
      />
      <Route
        path="/superadmin/dashboard/segmentation"
        element={
          <RoleRoute role="superadmin">
            <SuperAdminSegmentation />
          </RoleRoute>
        }
      />
      <Route
        path="/superadmin/dashboard/pricing-rules"
        element={
          <RoleRoute role="superadmin">
            <SuperAdminPricingRules />
          </RoleRoute>
        }
      />
      <Route
        path="/superadmin/dashboard/wallet"
        element={
          <RoleRoute role="superadmin">
            <WalletPage />
          </RoleRoute>
        }
      />

      <Route
        path="/manager/dashboard"
        element={
          <RoleRoute role="manager">
            <ManagerDashboard />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/tittat-application"
        element={
          <RoleRoute role="manager">
            <TitApplicationManagement />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/tittats"
        element={
          <RoleRoute role="manager">
            <TitTats />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/contracts"
        element={
          <RoleRoute role="manager">
            <ManagerContractManagement />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/accords"
        element={
          <RoleRoute role="manager">
            <ManagerAccords />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/live-bid-sessions"
        element={
          <RoleRoute role="manager">
            <AdminLiveBidSessions />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/auction-room/:sessionId"
        element={
          <RoleRoute role="manager">
            <AdminAuctionRoom />
          </RoleRoute>
        }
      />
      <Route
        path="/manager/dashboard/wallet"
        element={
          <RoleRoute role="manager">
            <WalletPage />
          </RoleRoute>
        }
      />

      {/* Artist Routes - Protected by Token + Role 'artist' */}
      <Route
        path="/artist/dashboard"
        element={
          <RoleRoute role="artist">
            <ArtistDashboard />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/my-artworks"
        element={
          <RoleRoute role="artist">
            <ArtWorks />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/tittat-application"
        element={
          <RoleRoute role="artist">
            <TokenApplicationManagement />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/tittats"
        element={
          <RoleRoute role="artist">
            <TitTatsArtist />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/contracts"
        element={
          <RoleRoute role="artist">
            <ArtistContractManagement />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/my-shop"
        element={
          <RoleRoute role="artist">
            <MyShop />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/shop-orders"
        element={
          <RoleRoute role="artist">
            <ShopOrders />
          </RoleRoute>
        }
      />
      <Route
        path="/artist/dashboard/wallet"
        element={
          <RoleRoute role="artist">
            <WalletPage />
          </RoleRoute>
        }
      />

      {/* Investor Routes - Protected by Token + Role 'investor' */}
      <Route
        path="/investor/dashboard"
        element={
          <RoleRoute role="investor">
            <InvestorDashboard />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/dashboard/holdings"
        element={
          <RoleRoute role="investor">
            <InvestorHoldings />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/dashboard/accords"
        element={
          <RoleRoute role="investor">
            <InvestorAccords />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/dashboard/trading"
        element={
          <RoleRoute role="investor">
            <TradingFloor />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/dashboard/bid-sessions"
        element={
          <RoleRoute role="investor">
            <LiveBidSessions />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/dashboard/wallet"
        element={
          <RoleRoute role="investor">
            <WalletPage />
          </RoleRoute>
        }
      />
      <Route
        path="/investor/auction/:sessionId"
        element={
          <RoleRoute role="investor">
            <AuctionRoom />
          </RoleRoute>
        }
      />
      {/* Catch all - Redirect to Home */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}